import React, { useEffect } from 'react';
import NewExperienceForm from './NewExperienceForm';
// import Experience from './temp_Experience';
import { connect } from 'react-redux';
import { removeExperience } from './actions';

const ExperienceList = ({ experiences = [], onRemovePressed }) => {

    const [showForm, setShowForm] = React.useState(false);
    useEffect(() => {
        if (experiences?.length <= 0) {
            setShowForm(true);
            return;
        }
        setShowForm(false);
    }, [experiences]);

    return (
        <div>
            {showForm && <NewExperienceForm />}
            {experiences?.length > 0 &&
                (
                    <div className="mb-3"
                        style={{ marginTop: 20, borderTop: '1px solid #e0e0e0' }}
                    >
                        <table className='table table-bordered'>
                            <thead>
                                <tr>    
                                    <th>Company Name</th>
                                    <th>Role</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Location</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {experiences.map((experience, key) => (
                                    <tr key={key}>
                                        <td>{experience.experience.company}</td>
                                        <td>{experience.experience.position}</td>
                                        <td>{experience.experience.start}</td>
                                        <td>{experience.experience.presentJob ? 'Present' : experience.experience.end}</td>
                                        <td>{experience.experience.location}</td>
                                        <td>
                                            <button
                                                className="btn btn-danger btn-sm rounded-circle"
                                                style={{ margin: 0 }}
                                                onClick={() => onRemovePressed(experience.experience)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                </svg>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )
            }
            {
                !showForm && <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <button
                        className="btn btn-primary"
                        onClick={() => setShowForm(true)}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                        </svg>
                        <span style={{ marginLeft: 5 }}>Add Experience</span>
                    </button>
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => ({
    experiences: state.experiences,
});

const mapDispatchToProps = dispatch => ({
    onRemovePressed: experience => dispatch(removeExperience(experience)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceList);